
import serviceImg from '../assets/images/service-bg.jpg';
import { Row, Col, Container } from "react-bootstrap";
import CardStacking from '../components/card-stacking';
import AnimatedCounter from '../components/AnimatedCounter';
import xImg from '../assets/images/bs1.png';

import realestate from '../assets/images/home.svg';
import beauty from '../assets/images/beauty.svg';
import ecom from '../assets/images/ecom.svg';
import interior from '../assets/images/interior.svg';
import education from '../assets/images/education.svg';
import hospitality from '../assets/images/hospitality.svg';

import pattern from '../assets/images/pattern-bg.webp';


import saturn from '../assets/images/saturn.svg';
import dna from '../assets/images/dna.svg';

const Services = () => {
    return (
        <div>

            <div className="service-section-bg" style={{ backgroundImage: `url(${serviceImg}` }}>

                <div className='service-overlay position-relative text-center'>
                    <h1 className='serive-page-title'><span className='outline-theme-text'>Services</span> That Drive <br />Scale - Sale - Revenue - ROI
                    </h1>
                </div>

            </div>

            <Container className='mb-5 pb-5'>
                <Row>
                    <Col md={10} className='mx-auto'>
                        <Row className="stats-cards">
                            <Col xl={4} md={6}>
                                <div className='item-card mb-4 bg-light'>
                                    <h2 className="item-text mb-1">
                                        <AnimatedCounter end={99} duration={2000} suffix="%" />
                                    </h2>
                                    <span className='item-desc'>Customer Satisfaction</span>
                                </div>
                            </Col>
                            {/* <Col xl={3} md={6} >
                        <div className='item-card mb-4'>
                            <img src={xImg} className='x-img' alt='x-img' />
                        </div>
                    </Col> */}
                            <Col xl={4} md={6}>
                                <div className='item-card mb-4 bg-light'>
                                    <h2 className="item-text mb-1">
                                        <AnimatedCounter end={50} duration={2000} suffix="+" />
                                    </h2>
                                    <span className='item-desc'>National Clients</span>
                                </div>
                            </Col>
                            <Col xl={4} md={6}>
                                <div className='item-card mb-4 bg-light'>
                                    <h2 className="item-text mb-1">
                                        <AnimatedCounter end={50} duration={2000} suffix="+" />
                                    </h2>
                                    <span className='item-desc'>International Clients </span>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>


            <Container className='my-5 py-5'>
                <CardStacking />
            </Container>

            <div className='position-relative'>
                <img src={saturn} alt='floating-icons' className='floating-icons left top' />
                <img src={dna} alt='floating-icons' className='floating-icons right bottom' />

                <Container className='mb-5 pb-5'>
                    <h1 className="outline-text testimonials-section-title custom-size"> Industries We<br />  Specialize In</h1>

                    <Row>
                        <Col lg={4}>
                            <div className='specilized-card' style={{ backgroundImage: `url(${pattern}` }} >
                                <img src={realestate} alt="real-estate" />
                                <h2>Real estate</h2>

                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='specilized-card' style={{ backgroundImage: `url(${pattern}` }}   >
                                <img src={beauty} alt="real-estate" />
                                <h2>Beauty & aesthetics</h2>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='specilized-card' style={{ backgroundImage: `url(${pattern}` }} >
                                <img src={ecom} alt="real-estate" />
                                <h2>E-commerce & retail</h2>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='specilized-card' style={{ backgroundImage: `url(${pattern}` }}  >
                                <img src={interior} alt="real-estate" />
                                <h2>Interior designs</h2>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='specilized-card' style={{ backgroundImage: `url(${pattern}` }}  >
                                <img src={education} alt="real-estate" />
                                <h2>Education</h2>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='specilized-card' style={{ backgroundImage: `url(${pattern}` }}  >
                                <img src={hospitality} alt="real-estate" />
                                <h2>Hospitality</h2>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </div>

        </div>
    )
};

export default Services;